import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the bold icon
 * 
 * @param {Object} props - The props of the component
 * @returns The bold icon
 */
const BoldIcon = (props) => (
  <Icon viewBox="0 0 8 10" {...props}>
    <path d="M0.533203 9.66683V0.333496H4.21654C4.93876 0.333496 5.60543 0.555718 6.21654 1.00016C6.82765 1.44461 7.1332 2.06127 7.1332 2.85016C7.1332 3.41683 7.00543 3.85294 6.74987 4.1585C6.49431 4.46405 6.25543 4.6835 6.0332 4.81683C6.31098 4.93905 6.61931 5.16683 6.9582 5.50016C7.29709 5.8335 7.46654 6.3335 7.46654 7.00016C7.46654 7.98905 7.10543 8.68072 6.3832 9.07516C5.66098 9.46961 4.9832 9.66683 4.34987 9.66683H0.533203ZM2.54987 7.80016H4.2832C4.81654 7.80016 5.14154 7.66405 5.2582 7.39183C5.37487 7.11961 5.4332 6.92238 5.4332 6.80016C5.4332 6.67794 5.37487 6.48072 5.2582 6.2085C5.14154 5.93627 4.79987 5.80016 4.2332 5.80016H2.54987V7.80016ZM2.54987 4.00016H4.09987C4.46654 4.00016 4.7332 3.90572 4.89987 3.71683C5.06654 3.52794 5.14987 3.31683 5.14987 3.0835C5.14987 2.81683 5.05543 2.60016 4.86654 2.4335C4.67765 2.26683 4.4332 2.1835 4.1332 2.1835H2.54987V4.00016Z" fill="currentColor" />
  </Icon>
);

export default React.memo(BoldIcon);
